import Axios from "@/plugins/Axios";

class HorariosService {
  async horariosConfiguracao() {
    const response = await Axios().get("horarios/listar-horarios");
    return response.data;
  }

  async horariosAll() {
    const response = await Axios().get("horarios/listar-horarios");
    return response.data;
  }

  async syncAll() {
    const response = await Axios().get(`horarios/listar-horarios`);
    return response.data;
  }

  async getHorariosDoTurnoDaTurma(turma_id) {
    const response = await Axios().get(`horarios/horarios-do-turno-da-turma/${turma_id}`);
    return response.data;
  }

  async getHorariosDaFranquia(franquia_id) {
    const response = await Axios().get(`horarios/listar-horarios-da-franquia/${franquia_id}`);
    return response.data;
  }
}

export default new HorariosService();
